import React from 'react'
import styled from 'styled-components'
import RenderMenu from './RenderMenu'
import Link from 'next/link'
import { trackCategoryClickedEvent } from '../../lib/analytics/events/category/CategoryClickedEvent'

import { SCREEN_SIZE } from '../../lib/Media'

const StyledContainer = styled.li`
  display: ${({ selected }) => (selected ? 'block' : 'none')};
  background-color: white;
  order: ${({ order }) =>
    order % 3 !== 0 ? 3 * (Math.floor(order / 3) + 1) + 1 : order + 1};
  flex-basis: 100%;
  margin-bottom: 0.5rem;

  ${SCREEN_SIZE.From.Tablet} {
    order: ${({ order }) =>
      order % 6 !== 0 ? 6 * (Math.floor(order / 6) + 1) + 1 : order + 1};
    margin-bottom: 0.5rem;
  }

  ${SCREEN_SIZE.From.Desktop} {
    display: none;
  }
`

const StyledCategoriesDetails = styled.ul`
  border-radius: 4px;
  padding: 1.125rem 0.5rem 0 1.5rem;
  list-style: none;

  & & {
    padding: 0 0 0 1.5rem;
  }

  ${SCREEN_SIZE.From.Tablet} {
    padding: 1.25rem 1.25rem 0 1.25rem;
  }

  ${SCREEN_SIZE.From.Desktop} {
    display: none;
  }
`

const LinkToAllProducts = styled.a`
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.43;
  color: #1557bf;
  text-decoration: none;
  display: block;
  padding: 1.25rem 1.25rem 0;
`
const LinkToParentCategory = styled(LinkToAllProducts)`
  padding: 0;
  margin-bottom: 1.125rem;
`

const SubCategoryLink = styled.div`
  cursor: pointer;
`

let checkoutAddressData = {}

function handleTrackCategoryClick(name, level) {
  trackCategoryClickedEvent({
    CATEGORY_NAME: name.toLowerCase(),
    CATEGORY_LEVEL: level,
    STORE_ID_DBP: checkoutAddressData?.storeId?.toString() ?? '',
    STORE_ID_SAP: checkoutAddressData?.clientId?.toString() ?? '',
  })
}

export function renderMenu(menu, name, url, id) {
  const handleClick = e => {
    e.stopPropagation()
    handleTrackCategoryClick(name, 2)
  }
  const updatedUrl = url && url.replace(/^\/?category\//, '')
  const nameToTrack = name ? encodeURIComponent(name) : ''
  const level = !name && !updatedUrl ? 1 : 3

  return (
    <StyledCategoriesDetails>
      {name && updatedUrl && (
        <li>
          <Link
            href={encodeURI(
              `/categoryDetails?slug=${encodeURIComponent(
                updatedUrl
              )}&exclude_ga_track_name=${nameToTrack}&exclude_ga_track_id=${id}`
            )}
            as={`/category/${updatedUrl}`}
            passHref
            legacyBehavior
          >
            <LinkToParentCategory onClick={handleClick}>
              View all
            </LinkToParentCategory>
          </Link>
        </li>
      )}
      {menu && menu.map((item, key) => renderMenuItem(item, key, level))}
    </StyledCategoriesDetails>
  )
}

function renderMenuItem(item, key, level) {
  return (
    <RenderMenu
      item={item}
      key={key}
      checkoutAddress={checkoutAddressData}
      level={level}
    />
  )
}

const CategoriesDetails = props => {
  const { selected, index, checkoutAddress } = props
  let { menu, url, name, id } = props.menu || {}
  url = url && url.replace(/^\/?category\//, '')
  const nameToTrack = name ? encodeURIComponent(name) : ''
  checkoutAddressData = checkoutAddress

  function handleTrackClickViewAll() {
    handleTrackCategoryClick(name, 1)
  }

  return (
    <StyledContainer
      selected={selected}
      index={index}
      data-testid="category-menu"
      order={index + 1}
    >
      {url && (
        <Link
          href={encodeURI(
            `/categoryDetails?slug=${encodeURIComponent(
              url
            )}&name=${nameToTrack}&id=${id}`
          )}
          as={`/category/${url}`}
          passHref
          legacyBehavior
        >
          <LinkToAllProducts onClick={handleTrackClickViewAll}>
            View all
          </LinkToAllProducts>
        </Link>
      )}
      <SubCategoryLink>{renderMenu(menu)}</SubCategoryLink>
    </StyledContainer>
  )
}

export default CategoriesDetails
